import React, { FC } from 'react';
import { Box } from '@mui/material';
import { IReviewNew } from '../../shared/interfaces/IReviewNew';
import { IMonitoring } from '../../shared/interfaces/IMonitoring';
import { CommunityManagement } from '../../shared/interfaces/ICommunityManagement';
import { IGmbLocation } from '../../shared/interfaces/IGmbLocation';
import FacebookReview from './Type/FacebookReview';
import GolocalReview from './Type/GolocalReview';
import AerzteReview from './Type/AerzteReview';
import EKomiReview from './Type/EKomiReview';
import KununuReview from './Type/KununuReview';
import HolidayCheckReview from './Type/HolidayCheckReview';
import StepStoneReview from './Type/StepStoneReview';
import TripAdvisorReview from './Type/TripAdvisorReview';
import HotelsReview from './Type/HotelsReview';
import AirbnbReview from './Type/AirbnbReview';
import AmazondeReview from './Type/AmazondeReview';
import AppstoreReview from './Type/AppstoreReview';
import PlaystoreReview from './Type/PlaystoreReview';
import IndeedReview from './Type/IndeedReview';
import ExpediaReview from './Type/ExpediaReview';
import BookingReview from './Type/BookingReview';
import IdealoReview from './Type/IdealoReview';
import TrustedShopsReview from './Type/TrustedShopsReview';
import SanegoReview from './Type/SanegoReview';
import YelpReview from './Type/YelpReview';
import TrustPilotReview from './Type/TrustPilotReview';
import JamedaReview from './Type/JamedaReview';
import GlassdoorReview from './Type/GlassdoorReview';
import ShopauskunftReview from './Type/ShopauskunftReview';
import GoogleReview from './Type/GoogleReview';
import MobileReview from './Type/MobileReview';
import AutoscoutReview from './Type/AutoscoutReview';
import TellowsReview from './Type/TellowsReview';
import GooglePlace from './Type/GooglePlace';
import Check24 from './Type/Check24';
import EbayReview from './Type/EbayReview';
import CapterraReview from './Type/CapterraReview';
import FewoReview from './Type/FewoReview';
import GutebankenReview from './Type/GutebankenReview';
import JobvotingReview from './Type/JobvotingReview';
import TrivagoReview from './Type/TrivagoReview';
import OmrReview from './Type/OmrReview';

interface Props {
  reviews: IReviewNew[];
  monitoring: IMonitoring[];
  commentingModule: boolean;
  hideHeader: boolean;
  hideFooter: boolean;
  location: IGmbLocation[];
}

const ReviewNew: FC<Props> = ({
  reviews,
  commentingModule,
  monitoring,
  location,
  hideHeader,
  hideFooter,
}) => {
  return (
    <Box>
      {reviews.map((reviewEntry: IReviewNew) => {
        const communityManagement: CommunityManagement | undefined = monitoring.find(
          (entry) => entry.company === reviewEntry.company
        )?.communityManagement;

        if (hideFooter) {
          console.log('NF1', reviewEntry);
        }
        const locationId =
          monitoring.find((entry) => entry.company === reviewEntry.company)?.id || '';

        const review = {
          facebook: (
            <FacebookReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          golocal: (
            <GolocalReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              reviewComment={reviewEntry.reviewComment}
              communityManagement={communityManagement}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          aerzte: (
            <AerzteReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          ekomi: (
            <EKomiReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          airbnb: (
            <AirbnbReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          kununu: (
            <KununuReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          holidaycheck: (
            <HolidayCheckReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          stepstone: (
            <StepStoneReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          tripadvisor: (
            <TripAdvisorReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          hotels: (
            <HotelsReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          amazonde: (
            <AmazondeReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          appstore: (
            <AppstoreReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          playstore: (
            <PlaystoreReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          indeed: (
            <IndeedReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          expedia: (
            <ExpediaReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          booking: (
            <BookingReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          idealo: (
            <IdealoReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          trustedshops: (
            <TrustedShopsReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          sanego: (
            <SanegoReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          yelp: (
            <YelpReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          trustpilot: (
            <TrustPilotReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          jameda: (
            <JamedaReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          glassdoor: (
            <GlassdoorReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          shopauskunft: (
            <ShopauskunftReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          google: (
            <GoogleReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              locationId={locationId}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              location={location}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          mobile: (
            <MobileReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          autoscout24: (
            <AutoscoutReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          tellows: (
            <TellowsReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          googleplace: (
            <GooglePlace
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          check24: (
            <Check24
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          ebay: (
            <EbayReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          capterra: (
            <CapterraReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          fewo: (
            <FewoReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          gutebanken: (
            <GutebankenReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          jobvoting: (
            <JobvotingReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          trivago: (
            <TrivagoReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          omr: (
            <OmrReview
              key={reviewEntry.id}
              commentingModule={commentingModule}
              id={reviewEntry.id}
              company={reviewEntry.company}
              createdAt={reviewEntry.createdAt}
              updatedAt={reviewEntry.updatedAt}
              identifier={reviewEntry.identifier}
              review={reviewEntry.review}
              firstScrapedAt={reviewEntry.firstScrapedAt}
              lastScrapedAt={reviewEntry.lastScrapedAt}
              scrapeCount={reviewEntry.scrapeCount}
              reviewerRole={reviewEntry.reviewerRole}
              platform={reviewEntry.platform}
              communityManagement={communityManagement}
              reviewComment={reviewEntry.reviewComment}
              note={reviewEntry.note}
              deletion={reviewEntry.deletion}
              deleted={reviewEntry.deleted}
              timestamp={reviewEntry.timestamp}
              hideHeader={hideHeader}
              hideFooter={hideFooter}
              history={reviewEntry.history}
            />
          ),
          default: <></>,
        };
        return review[reviewEntry.platform as keyof typeof review] ?? review['default'];
      })}
    </Box>
  );
};

export default ReviewNew;
